import { colors } from '@globals/themes/defaultTheme'
import { SxProps } from '@mui/material/styles'

export const filterAdornmentStyle: SxProps = { color: `${colors.grayPrimary} !important` }

/** Styles for selectable rows in filter dropdowns (DynamicSelect, TeamTypeFilter, etc.) */
export const filterListItemStyle: SxProps = {
  '&:hover': {
    backgroundColor: `${colors.blueExtraLight} !important`,
  },
  cursor: 'pointer',
}

/** Overrides defaultTheme 684px maxWidth for filter inputs inside bottom drawers (tablet/mobile). */
export const mobileFilterDrawerMaxWidth: SxProps = {
  '& .MuiOutlinedInput-root': { maxWidth: 'none' },
  '& .MuiFormControl-root': { maxWidth: 'none' },
}
